import { gql } from '@apollo/client';

export const removeEventSchemaMutation = gql`
  mutation removeEventSchema($id: uuid!) {
    update_schema_library_event_schemas_by_pk(pk_columns: { id: $id }, _set: { deletedAt: "now()" }) {
      id
    }
  }
`;

export function buildVariables({ id }) {
  return {
    id,
  };
}
